var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-button-rejectbirthdate",class:_vm.className,on:{"click":_vm.Handle_OnClick}},[_c('router-link',{staticClass:"btn btn-secondary",attrs:{"to":{ name: 'PageBirthdate' }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.language.button_redo)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }